import React from 'react';
import classNames from 'classnames';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import TimeUtil from 'time';
import OverrideIcon from 'main/components/show/cuesheet/overrideIcon.jsx';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';

import Tappable from 'react-tappable';

export default React.createClass({
  mixins: [PureRenderMixin],

  render() {
    const { rowIndex, item } = this.props;

    if (!item.get('displayPresetClock')) return null;

    return (
      <Tappable
        onTap={() =>
          CuesheetCellActions.startEditingItemCell(
            rowIndex,
            EditableCellTypes.ItemPresetDuration,
          )
        }
      >
        {this._getDisplayNode()}
      </Tappable>
    );
  },

  _getDisplayNode() {
    const value = this._getDisplayValue();
    const { presetDurationDisplayType, rowIndex, item } = this.props;

    let presetDuration = TimeUtil.getShorthandFormattedPresetDuration(value);

    if (presetDurationDisplayType === TimeDisplayTypes.sixDigitTime) {
      presetDuration = TimeUtil.getFormattedDuration(value);
    }
    if (presetDurationDisplayType === TimeDisplayTypes.presetTime) {
      presetDuration = TimeUtil.getFormattedPresetDuration(value);
    }

    let classes = classNames('csr-cell csr-preset-time-cell', {
      'cs-preset-time-cell-over': value < 0,
    });

    return (
      <span className={classes}>
        <OverrideIcon
          field="presetDurationInSeconds"
          rowIndex={rowIndex}
          item={item}
        />
        {presetDuration}
      </span>
    );
  },

  _getDisplayValue() {
    return this.props.item.get('presetDurationInSecondsAdjusted');
  },
});
